var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('div',{attrs:{"id":"container"}},_vm._l((13),function(i){return _c('v-skeleton-loader',{key:i,staticClass:"item",attrs:{"width":"400px","height":"300px","type":"card","loading":_vm.loading}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }